<template>
  <div class="dimed wrap" v-if="helperYn == true" style="z-index: 7">
    <div class="layer layer--bottom">
      <div class="layer__header fix-h">
        <div class="lyr-title">{{ $t('Modal.Helper.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.Helper.msg2') }}<br />
          {{ $t('Modal.Helper.msg3') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.Helper.msg4') }}</div>
      </div>
      <div class="layer__body">
        <div class="flex-row">
          <button class="btn btn-pop-lg btn--shadow btn--white btn-anim" @mouseup="$emit('setHelperHeight')">
            <span class="txt">
              <em class="ft--2xlg ft--bold">{{ $t('Modal.Helper.msg5') }}</em>
              {{ $t('Modal.Helper.msg6') }}
            </span>
            <i class="ico-helper"></i>
          </button>
          <button class="btn btn-pop-lg btn--shadow btn--dark btn-anim" @mouseup="$emit('setDarkYn')">
            <span class="txt">
              <em class="ft--2xlg ft--bold">{{ $t('Modal.Helper.msg7') }}</em>
              {{ $t('Modal.Helper.msg8') }}
            </span>
            <i class="ico-eye"></i>
          </button>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" @mouseup="$emit('closeHelper')">{{ $t('Modal.Helper.msg9') }}</button>
        <button
          class="btn btn--submit btn-anim"
          @mouseup="
            staffCallAudio();
            $emit('setHelper');
          "
        >
          {{ $t('Modal.Helper.msg10') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'helper',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  props: {
    helperYn: Boolean,
  },
  mounted() {
    this.$changeDarkMode(this.darkModeYn);
  },
  methods: {
    staffCallAudio() {
      try {
        audioHelper.playAudio('00051', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    helperYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00054', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/intro.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/intro-dark.css" scoped></style>
<style scoped></style>
